/* Ardor Table Cover Designer: cover type and size (table throws, fitted, stretch and round covers, table runners), 3 or 4
sided, the runner combo's throw color, the cover color, quantity, delivery, live price, artwork panel by panel (front,
top, sides and back, each edited upright, with copy-to), the whole cover as printed, 3D preview, proof approval, cart, quote.
Ardor Printing. New Oct 12, 2026. Made from a copy of ardor-table-builder.js (unchanged) by the patch list
table/core/builder.patch. Loaded by sections/ardor-table-builder-ws.liquid.
Every cover is drawn at true proportions from its print template (window.ArdorTableSpecs, assets/ardor-table-specs.js):
template page, cut line, table top, table edges and the panels. Each panel is edited on its own upright page; the whole
cover (every panel turned onto its place on the template, the cover color everywhere else) is what the "Whole cover" view,
the 3D view, the proof and the print file use. Works with ardor-table-layers.js (text and clipart), ardor-table-ai.js
(AI design), ardor-table3d.js (3D view) and ardor-table-pdf.js (proof and print PDF). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- table covers, variants and prices ----------
  // One Shopify variant per cover (product "Custom Table Covers", option "Cover", SKU "TC-<KEY>"). The section writes every
  // variant into the config: k = SKU, t = Cover option, id, c = price of ONE cover in cents, a = available. The cart line
  // quantity is the number of covers. The runner + solid throw combo's throw color is a line item property ("Throw color").
  // FALLBACK (window.ArdorTableSpecs.fallback, cents per cover) is only used when the config has no variants, so a price
  // always shows; Add to cart then asks the customer to call.
  var SPECS = window.ArdorTableSpecs || {};
  var CV = SPECS.covers || {};
  var FALLBACK = SPECS.fallback || {};
  // the solid throw colors for the runner + throw combo, per throw size (SPECS.colors = { "6": [...], "8": [...] } or "all")
  function colorsFor(cv) { var C = SPECS.colors || {}, l = Array.isArray(C) ? C : (C[String(cv && cv.throwFt)] || C.all || []); return l.filter(function (x) { return x && x.name && /^#[0-9A-Fa-f]{6}$/.test(x.hex || ''); }); }
  var FAMS = [
    { id: 'throw', name: 'Table throw', plural: 'Table throws', short: 'table throw', noun: ['table throw', 'table throws'] },
    { id: 'fitted', name: 'Fitted table cover', plural: 'Fitted covers', short: 'fitted table cover', noun: ['fitted cover', 'fitted covers'] },
    { id: 'stretch', name: 'Stretch table cover', plural: 'Stretch covers', short: 'stretch table cover', noun: ['stretch cover', 'stretch covers'] },
    { id: 'round', name: 'Round table cover', plural: 'Round covers', short: 'round table cover', noun: ['round cover', 'round covers'] },
    { id: 'runner', name: 'Table runner', plural: 'Table runners', short: 'table runner', noun: ['table runner', 'table runners'] }
  ];
  var MAX_QTY = 100;
  var SAFE = 1; // inches inside the panel edges for the dashed red safe line when the template gives none
  var MAX_FILE = 25 * 1024 * 1024;
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';
  var BG_SWATCHES = [['White', '#FFFFFF'], ['Black', '#000000']];
  var ORDER = (SPECS.order || Object.keys(CV)).filter(function (k) { return CV[k] && CV[k].panels && CV[k].panels.length && CV[k].tpl; });

  function famOf(id) { for (var i = 0; i < FAMS.length; i++) if (FAMS[i].id === id) return FAMS[i]; return FAMS[0]; }
  var KEY_UC = {}; Object.keys(CV).forEach(function (k) { KEY_UC[k.toUpperCase()] = k; });
  // a cover key as written in the specs (runner keys have a lowercase x: RN-24x72), any letter case accepted
  function normKey(s) { s = String(s || '').trim(); return CV[s] ? s : (KEY_UC[s.toUpperCase()] || ''); }
  function keyFromText(t) { var s = String(t || '').trim().toLowerCase(); if (!s) return ''; for (var i = 0; i < ORDER.length; i++) if (String(CV[ORDER[i]].name || '').toLowerCase() === s) return ORDER[i]; return ''; }
  // the cover of a variant: from its SKU (TC-<KEY>), else from the Cover option text
  function keyOf(v) { var m = /^TC-(.+)$/i.exec(String(v.k || '').trim()); return (m && normKey(m[1])) || keyFromText(v.t); }
  var VAR = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var key = keyOf(v); if (!key) return;
    var p = Math.round(Number(v.c));
    VAR[key] = { id: v.id || null, cents: isFinite(p) && p > 0 ? p : 0, available: v.a !== false, sku: String(v.k || '') };
    LIVE = true;
  });
  // the variant for a cover. none = the product has no such variant (not offered)
  function variantFor(key) {
    var v = VAR[key];
    if (v) return v;
    if (LIVE) return { id: null, cents: 0, available: false, none: true };
    var x = Math.round(Number(FALLBACK[key])) || 0;
    return { id: null, cents: x, available: false, none: !x };
  }
  function coversShown() { return ORDER.filter(function (k) { return !variantFor(k).none; }); }
  function famsShown() { var ks = coversShown(); return FAMS.filter(function (f) { return ks.some(function (k) { return CV[k].fam === f.id; }); }); }
  function famFrom(fid) { var lo = 0; coversShown().forEach(function (k) { if (CV[k].fam !== fid) return; var x = variantFor(k).cents; if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }
  function colorOf(cv, name) { var l = colorsFor(cv); for (var i = 0; i < l.length; i++) if (l[i].name === name) return l[i]; return null; }
  function normHex(h) { h = String(h || '').trim(); if (/^#[0-9a-f]{3}$/i.test(h)) h = '#' + h.slice(1).split('').map(function (x) { return x + x; }).join(''); return /^#[0-9a-f]{6}$/i.test(h) ? h.toUpperCase() : ''; }
  function nounOf(c, n) { var w = c.fam.noun || ['table cover', 'table covers']; return n === 1 ? w[0] : w[1]; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // ---------- panel geometry ----------
  // Inches on the cover's print template (page top-left, y down). Every panel (front, top, sides, back) is edited upright:
  // the way a person standing at that side reads it (the top of the art next to the table top). rect = the panel's area on
  // the template as printed, rot = clockwise degrees its upright art is turned when it is placed there. Template areas that
  // belong to no panel (loose throw corners) show the cover color only.
  function R(a) { return a && a.length === 4 ? a.map(Number) : [0, 0, 0, 0]; }
  function panelsOf(key) { return (CV[key] && CV[key].panels) || []; }
  function panelOf(key, id) { var ps = panelsOf(key); for (var i = 0; i < ps.length; i++) if (ps[i].id === id) return ps[i]; return null; }
  function rotOf(p) { return ((Math.round((+p.rot || 0) / 90) * 90) % 360 + 360) % 360; }
  // the upright size of a panel: its editing page
  function pageOf(p) { var r = R(p.rect), q = rotOf(p) % 180 !== 0; return { W: q ? r[3] : r[2], H: q ? r[2] : r[3] }; }
  // upright panel inches -> template inches, as a canvas transform [a, b, c, d, e, f] (x' = a u + c v + e, y' = b u + d v + f)
  function matOf(p) {
    var r = R(p.rect), x = r[0], y = r[1], w = r[2], h = r[3];
    switch (rotOf(p)) {
      case 90: return [0, 1, -1, 0, x + w, y];
      case 180: return [-1, 0, 0, -1, x + w, y + h];
      case 270: return [0, -1, 1, 0, x, y + h];
      default: return [1, 0, 0, 1, x, y];
    }
  }
  function inv(m) { var d = m[0] * m[3] - m[1] * m[2]; return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[3] * m[4]) / d, (m[1] * m[4] - m[0] * m[5]) / d]; }
  function apply(m, x, y) { return [m[0] * x + m[2] * y + m[4], m[1] * x + m[3] * y + m[5]]; }
  // a box -> the box it covers after the transform m
  function boxTo(m, b) {
    var a = apply(m, b.x, b.y), c = apply(m, b.x + b.w, b.y + b.h);
    return { x: Math.min(a[0], c[0]), y: Math.min(a[1], c[1]), w: Math.abs(c[0] - a[0]), h: Math.abs(c[1] - a[1]) };
  }
  function bbox(p) { var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9; p.forEach(function (q) { x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); }); return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 }; }
  function cutBox(cv) {
    var c = cv.cut || {};
    if (c.type === 'circle') return { x: c.cx - c.r, y: c.cy - c.r, w: 2 * c.r, h: 2 * c.r };
    if (c.type === 'poly' && c.pts && c.pts.length > 2) return bbox(c.pts);
    if (c.type === 'pieces' && c.pieces) { var all = []; Object.keys(c.pieces).forEach(function (k) { var b = cutBox({ cut: c.pieces[k], tpl: cv.tpl }); all.push([b.x, b.y], [b.x + b.w, b.y + b.h]); }); if (all.length) return bbox(all); }
    var r = c.rect || [0, 0, cv.tpl[0], cv.tpl[1]];
    return { x: +r[0], y: +r[1], w: +r[2], h: +r[3] };
  }
  // the template area a panel prints on: its rect, its circle (round cover tops) or its piece outline (stretch covers)
  function panelPath(ctx, p) {
    if (p.clip && p.clip.circle) { var q = p.clip.circle; ctx.moveTo(q[0] + q[2], q[1]); ctx.arc(q[0], q[1], q[2], 0, Math.PI * 2); }
    else if (p.clip && p.clip.poly && p.clip.poly.length > 2) polyPath(ctx, p.clip.poly);
    else { var r = R(p.rect); ctx.rect(r[0], r[1], r[2], r[3]); }
  }
  function clipPanel(ctx, p) { ctx.beginPath(); panelPath(ctx, p); ctx.clip(); }
  function cutPath(ctx, cv) {
    var c = cv.cut || {};
    if (c.type === 'circle') { ctx.moveTo(c.cx + c.r, c.cy); ctx.arc(c.cx, c.cy, c.r, 0, Math.PI * 2); }
    else if (c.type === 'poly' && c.pts && c.pts.length > 2) polyPath(ctx, c.pts);
    else if (c.type === 'pieces' && c.pieces) Object.keys(c.pieces).forEach(function (k) { cutPath(ctx, { cut: c.pieces[k], tpl: cv.tpl }); });
    else { var r = c.rect || [0, 0, cv.tpl[0], cv.tpl[1]]; ctx.rect(r[0], r[1], r[2], r[3]); }
  }
  // the safe area of a panel in TEMPLATE inches: the panel inside the cut line, SAFE in from every edge (the table edge too)
  function safeOf(cv, p) {
    var s = +cv.safe || SAFE;
    if (p.safePoly && p.safePoly.length > 2) return { poly: p.safePoly };
    if (p.clip && p.clip.circle) { var q = p.clip.circle; return { circle: [q[0], q[1], Math.max(1, q[2] - s)] }; }
    var r = R(p.rect), cb = cutBox(cv);
    var x0 = Math.max(r[0], cb.x), y0 = Math.max(r[1], cb.y), x1 = Math.min(r[0] + r[2], cb.x + cb.w), y1 = Math.min(r[1] + r[3], cb.y + cb.h);
    return { rect: [x0 + s, y0 + s, Math.max(1, x1 - x0 - 2 * s), Math.max(1, y1 - y0 - 2 * s)] };
  }
  // the same safe area as an upright box on the panel's page (new text and logos go there)
  function safeBoxOf(c, p) {
    var s = safeOf(c.cv, p), b;
    if (s.circle) { var h = s.circle[2] / Math.SQRT2; b = { x: s.circle[0] - h, y: s.circle[1] - h, w: 2 * h, h: 2 * h }; }
    else if (s.poly) b = bbox(s.poly);
    else b = { x: s.rect[0], y: s.rect[1], w: s.rect[2], h: s.rect[3] };
    var r = boxTo(inv(matOf(p)), b);
    return { x: r.x, y: r.y, w: Math.max(1, r.w), h: Math.max(1, r.h) };
  }
  function clipOf(p) { return p.clip && p.clip.circle ? { circle: p.clip.circle.map(Number) } : (p.clip && p.clip.poly ? { poly: p.clip.poly } : { rect: R(p.rect) }); }

  var S = { key: '', bg: '#FFFFFF', color: '', qty: 1, delivery: 'ship', panel: 'front', view: 'panel', back: false, artVer: 0 };
  var ART = {}; // one artwork per panel id (front, top, left, right, back)
  var eng = null;
  (function () {
    var ks = coversShown(), want = normKey(CONF.defaultCover) || 'TT6-4';
    S.key = ks.indexOf(want) >= 0 ? want : (ks[0] || ORDER[0] || '');
    if (S.key && !panelOf(S.key, 'front')) S.panel = panelsOf(S.key)[0].id;
  })();

  // c.Wi x c.Hi = the page being edited in inches: the current panel upright, or (Whole cover view) the template page.
  // c.tplW x c.tplH = the template page (what is printed, bleed included). c.qty = covers.
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var key = CV[s.key] ? s.key : (coversShown()[0] || ORDER[0]);
    var cv = CV[key], ps = panelsOf(key), p = panelOf(key, s.panel) || ps[0];
    var qty = Math.max(1, Math.min(MAX_QTY, Math.round(Number(s.qty)) || 1));
    var combo = !!cv.combo, pg = pageOf(p);
    // sides: 3 or 4 for the covers sold both ways (table throws, fitted covers), else 0
    var c = { key: key, cv: cv, fam: famOf(cv.fam), sides: cv.fam === 'throw' || cv.fam === 'fitted' ? (+cv.sides || 0) : 0, opt: String(cv.opt || ''), panels: ps, panel: p, pid: p.id, whole: s.view === 'whole', page: pg,
      tplW: +cv.tpl[0], tplH: +cv.tpl[1], qty: qty, delivery: s.delivery === 'pickup' ? 'pickup' : 'ship', v: variantFor(key),
      combo: combo, color: combo ? (colorOf(cv, s.color) || colorsFor(cv)[0] || null) : null, bg: normHex(s.bg) || '#FFFFFF', artVer: s.artVer };
    c.Wi = c.whole ? c.tplW : pg.W; c.Hi = c.whole ? c.tplH : pg.H;
    return c;
  }
  // each = one cover; charged = what goes in the cart
  function price(c) {
    var each = c.v.cents / 100;
    return { each: each, charged: each * c.qty, unit: each, vid: c.v.id, disc: 0 };
  }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function inchTxt(n) { return fmt(Math.round(n * 4) / 4); }
  function sizeName(key) { var cv = CV[key]; return (cv && cv.szName) || key; }
  function sizeSub(key) { var cv = CV[key]; return (cv && cv.szSub) || ''; }
  function famLabel(c) { return c.fam.id === 'runner' && c.combo ? 'Table runner + ' + c.cv.throwFt + ' ft solid color throw' : c.fam.name; }
  function coverLabel(c) { return c.cv.name || (c.fam.name + ' ' + sizeName(c.key)); }
  function fitsTxt(c) {
    var t = c.cv.table || {};
    if (t.shape === 'round') return 'fits a ' + inchTxt(t.diameter) + ' in round table' + (t.height ? ', ' + inchTxt(t.height) + ' in high' : '');
    return 'fits a ' + inchTxt(t.length) + ' x ' + inchTxt(t.depth) + ' in table' + (t.height ? ', ' + inchTxt(t.height) + ' in high' : '');
  }
  function sizeLabel(c) { return sizeName(c.key) + ' (' + fitsTxt(c) + ')'; }
  function sidesLabel(c) { return c.sides === 3 ? '3 sided (open back)' : (c.sides === 4 ? '4 sided (closed back)' : ''); }
  function sizeChip(c) { return c.fam.id === 'runner' ? sizeName(c.key) + ' runner' + (c.combo ? ' + ' + c.cv.throwFt + ' ft throw' : '') : (c.fam.id === 'round' ? sizeName(c.key) : sizeName(c.key) + ' ' + c.fam.short); }
  function bgLabel(c) { var sw = BG_SWATCHES.filter(function (x) { return x[1] === c.bg; })[0]; return (sw ? sw[0] + ' ' : '') + c.bg; }
  function colorLabel(c) { return c.color ? c.color.name : ''; }
  function qtyLabel(n, c) { return n + ' ' + nounOf(c || cfg(), n); }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)'; }
  function panelName(p) { return (p && p.name) || 'Panel'; }
  function tplTxt(c) { return fmt(c.tplW) + ' x ' + fmt(c.tplH) + ' in'; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new cover: keep each panel's art, fitted again to its new panel (Fill for pictures, Fit for files)
  function resetArt() { Object.keys(ART).forEach(function (k) { var a = ART[k]; if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } }); }
  function pickCover(key) {
    key = normKey(key);
    if (!key || key === S.key) return;
    resetArt(); lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5;
    var patch = { key: key, artVer: S.artVer + 1 };
    if (!panelOf(key, S.panel)) patch.panel = (panelOf(key, 'front') || panelsOf(key)[0]).id;
    set(patch);
  }
  // a new cover type: the same size and version there when it has them, else that type's usual cover
  function pickFamily(fid) {
    var c = cfg(); if (c.cv.fam === fid) return;
    var ks = coversShown().filter(function (k) { return CV[k].fam === fid; }); if (!ks.length) return;
    var same = ks.filter(function (k) { return CV[k].sz === c.cv.sz && String(CV[k].opt || '') === c.opt; })[0];
    var dflt = SPECS.famDefault && ks.indexOf(SPECS.famDefault[fid]) >= 0 ? SPECS.famDefault[fid] : ks[0];
    pickCover(same || dflt);
  }
  // a new size of the same type: keep the version (3 or 4 sided; runner only or with a throw) when that size has it
  function pickSize(sz) {
    var c = cfg();
    var ks = coversShown().filter(function (k) { return CV[k].fam === c.cv.fam && CV[k].sz === sz; }); if (!ks.length) return;
    pickCover(ks.filter(function (k) { return String(CV[k].opt || '') === c.opt; })[0] || ks[0]);
  }
  // runners: a new width or length (rw / rl in inches), keeping the other and the version
  function pickRunner(w, l) {
    var c = cfg(), W = w || c.cv.rw, Lg = l || c.cv.rl;
    var ks = coversShown().filter(function (k) { return CV[k].fam === 'runner' && +CV[k].rw === +W && +CV[k].rl === +Lg; });
    if (!ks.length && w) ks = coversShown().filter(function (k) { return CV[k].fam === 'runner' && +CV[k].rw === +W; });
    if (!ks.length && l) ks = coversShown().filter(function (k) { return CV[k].fam === 'runner' && +CV[k].rl === +Lg; });
    if (ks.length) pickCover(ks.filter(function (k) { return String(CV[k].opt || '') === c.opt; })[0] || ks[0]);
  }
  // the version of this size: 3 or 4 sided, or runner only / with a 6 ft or 8 ft solid throw
  function pickOpt(o) {
    var c = cfg(); if (o === c.opt) return;
    var k = coversShown().filter(function (x) { return CV[x].fam === c.cv.fam && CV[x].sz === c.cv.sz && String(CV[x].opt || '') === o; })[0];
    if (k) pickCover(k);
  }
  function pickColor(name) { if (name !== S.color) set({ color: name, artVer: S.artVer + 1 }); }
  function setQty(n) { n = Math.max(1, Math.min(MAX_QTY, Math.round(Number(n)) || 1)); if (n !== S.qty) set({ qty: n }); else render(); }
  // the cover color: everywhere the art does not cover, the unpanelled corners included
  function setBg(hex) { hex = normHex(hex); if (!hex || hex === S.bg) return; S.bg = hex; S.artVer++; render(); }
  function syncBgUi() {
    var inp = $('[data-abb-bg]'); if (inp && document.activeElement !== inp && inp.value.toUpperCase() !== S.bg) inp.value = S.bg.toLowerCase();
  }
  // the panel being edited, or the whole cover (view only)
  function pickPanel(id) {
    if (id === 'whole') { if (S.view !== 'whole') { S.view = 'whole'; lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; render(); view3d('home'); } return; }
    var c = cfg(); if (!panelOf(c.key, id)) return;
    if (S.view === 'panel' && S.panel === id) return;
    S.view = 'panel'; S.panel = id; lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5;
    render();
    view3d(view3dFor(id));
  }
  function view3dFor(id) { return { front: 'front', back: 'back', left: 'left', right: 'right', top: 'top' }[id] || 'home'; }
  // "Copy this panel to...": the art (same file, same place on the panel, scaled to fit when the sizes differ) and the
  // panel's text and clipart. It replaces what the other panel had.
  function copyArt(a, from, to) {
    if (!a) return null;
    var b = Object.assign({}, a), P0 = pageOf(from), P1 = pageOf(to);
    if (a.mode === 'custom') { var g = geom(a, P0.W, P0.H), k = Math.min(P1.W / P0.W, P1.H / P0.H); b.rw = g.w * k / P1.W; }
    return b;
  }
  function copyPanel(target) {
    var c = cfg(); if (c.whole) return;
    var from = c.panel, ids = target === 'drops' ? c.panels.filter(function (p) { return p.id !== from.id && p.id !== 'top'; }).map(function (p) { return p.id; }) : [target];
    var LY = window.ArdorTableLayers, done = [], waits = [];
    ids.forEach(function (id) {
      var to = panelOf(c.key, id); if (!to || to.id === from.id) return;
      ART[id] = copyArt(ART[from.id], from, to);
      if (LY && LY.copyFace) waits.push(LY.copyFace(from.id, id));
      done.push(panelName(to).toLowerCase());
    });
    if (!done.length) return;
    S.artVer++; render();
    Promise.all(waits).then(function () { S.artVer++; render(); }, function () {});
    toast('Copied the ' + panelName(from).toLowerCase() + ' to the ' + (done.length > 1 ? done.slice(0, -1).join(', ') + ' and ' + done[done.length - 1] : done[0]) + '.');
  }

  // ---------- artwork ----------
  function artFor(face) { return ART[face] || null; }
  // v2: text, clipart and logo layers added in the builder (ardor-table-layers.js), one set per panel
  function layerFace(face) { return face; }
  function hasLayers(f) { return !!(window.ArdorTableLayers && window.ArdorTableLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorTableLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorTableLayers; if (!LY || !LY.list) return '';
    var keys = c.panels.map(function (p) { return p.id; });
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? panelName(panelOf(c.key, k)) + ': ' + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  // art turned 90 or 270 degrees: its box is as wide as the picture is tall
  function rot90(a) { return !!a && (a.rot === 90 || a.rot === 270); }
  function geom(a, Wi, Hi) {
    var ia = rot90(a) ? a.natH / a.natW : a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW, rot: a.rot || 0 };
  }
  // draw a picture into its placed box g (the box of the art as turned), turned g.rot degrees clockwise
  function drawRot(ctx, img, g) {
    if (!g.rot) { ctx.drawImage(img, g.x, g.y, g.w, g.h); return; }
    var q = g.rot === 90 || g.rot === 270, dw = q ? g.h : g.w, dh = q ? g.w : g.h;
    ctx.save();
    ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
    ctx.rotate(g.rot * Math.PI / 180);
    ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = S.bg || '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorTableLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = S.bg || a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      drawRot(ctx, a.img, g);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorTableLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor Table Cover Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // a file goes on the panel being edited (from the Whole cover view: on the last panel edited, which the view goes back to)
  function uploadFace(file) {
    var c = cfg();
    if (S.view === 'whole' && file) { S.view = 'panel'; S.panel = c.pid; }
    return c.pid;
  }
  function artInUse(a) { return Object.keys(ART).some(function (k) { return ART[k] === a; }); }

  function loadFile(file, face) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF', rot: 0 };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a);
      ART[face] = a; S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (artInUse(a)) { S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your table cover, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your table cover.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your table cover.' + tail;
  }
  function needsEmailProof() { var c = cfg(); return c.panels.some(function (p) { var a = ART[p.id]; return a && a.noPreview; }); }

  // ---------- drawing: one panel upright (2D editor) and the whole cover as printed (2D view, 3D, proof) ----------
  function polyPath(ctx, p) { if (!p || !p.length) return; ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.closePath(); }
  var checkerCv = null;
  function checker(ctx, u) {
    try {
      if (!checkerCv) {
        checkerCv = document.createElement('canvas'); checkerCv.width = checkerCv.height = 16;
        var x = checkerCv.getContext('2d'); x.fillStyle = '#ECECEF'; x.fillRect(0, 0, 16, 16); x.fillStyle = '#DADADF'; x.fillRect(0, 0, 8, 8); x.fillRect(8, 8, 8, 8);
      }
      var pat = ctx.createPattern(checkerCv, 'repeat');
      if (pat && pat.setTransform && window.DOMMatrix) { pat.setTransform(new DOMMatrix().scale(u * 0.75)); return pat; }
    } catch (e) {}
    return '#E6E6EA';
  }
  function isDark(hex) { var n = parseInt(String(hex || '#FFFFFF').slice(1), 16); return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) < 140; }
  // the guides in TEMPLATE inches: outside the cut line dimmed (it is cut off), the cut line and the table edges (dashed).
  // u = inches per screen pixel (line widths).
  function drawTplGuides(ctx, cv, u) {
    var W = +cv.tpl[0], H = +cv.tpl[1];
    ctx.save();
    ctx.setLineDash([]);
    ctx.beginPath(); ctx.rect(-W, -H, 3 * W, 3 * H); cutPath(ctx, cv);
    ctx.globalAlpha = 0.86; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    ctx.beginPath(); cutPath(ctx, cv);
    ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    if (cv.folds && cv.folds.length) {
      ctx.beginPath();
      cv.folds.forEach(function (f) { ctx.moveTo(f[0], f[1]); ctx.lineTo(f[2], f[3]); });
      ctx.setLineDash([]); ctx.lineWidth = u * 2.4; ctx.strokeStyle = 'rgba(255,255,255,0.6)'; ctx.stroke();
      ctx.setLineDash([u * 7, u * 5]); ctx.lineWidth = u * 1.3; ctx.strokeStyle = 'rgba(12,13,13,0.7)'; ctx.stroke();
    }
    ctx.setLineDash([]);
    ctx.restore();
  }
  // the guides on one panel, drawn on its upright page: the template guides turned with the panel, the part of the panel
  // outside a round top dimmed, and the dashed red safe line
  function drawPanelGuides(ctx, c, p, u) {
    var iv = inv(matOf(p)), s = safeOf(c.cv, p), r = R(p.rect);
    ctx.save();
    ctx.transform(iv[0], iv[1], iv[2], iv[3], iv[4], iv[5]);
    drawTplGuides(ctx, c.cv, u);
    if (p.clip && (p.clip.circle || p.clip.poly)) {
      ctx.beginPath(); ctx.rect(r[0], r[1], r[2], r[3]); panelPath(ctx, p);
      ctx.globalAlpha = 0.7; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    }
    ctx.beginPath();
    if (s.circle) ctx.arc(s.circle[0], s.circle[1], s.circle[2], 0, Math.PI * 2); else if (s.poly) polyPath(ctx, s.poly); else ctx.rect(s.rect[0], s.rect[1], s.rect[2], s.rect[3]);
    ctx.setLineDash([]); ctx.lineWidth = u * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)'; ctx.stroke();
    ctx.setLineDash([u * 6, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)'; ctx.stroke();
    ctx.setLineDash([]);
    ctx.restore();
  }
  // one panel upright (the 2D editor); face = the panel id
  function drawFlat(ctx, c, Wi, Hi, face, guides, u) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = S.bg || '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      if (guides) {
        ctx.save();
        ctx.fillStyle = isDark(S.bg) ? 'rgba(255,255,255,0.55)' : '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = '600 ' + Math.max(0.5, Math.min(Hi * 0.12, Wi * 0.06)) + 'px Arial, sans-serif';
        ctx.fillText('Your artwork goes here', Wi / 2, Hi / 2);
        ctx.restore();
      }
    }
    if (!guides) return;
    var p = panelOf(c.key, face) || c.panel;
    drawPanelGuides(ctx, c, p, u || Math.max(Wi, Hi) / 600);
  }
  // the whole cover as printed: the cover color everywhere, every panel's design turned onto its place. This one drawing
  // is what the "Whole cover" view, the 3D view and the proof show; the print file places the same panels the same way.
  // opt.guides: cut line, table edges, panel edges and names. opt.u: inches per screen pixel.
  function paintCover(ctx, c, opt) {
    opt = opt || {};
    var W = c.tplW, H = c.tplH;
    ctx.save();
    ctx.fillStyle = S.bg || '#FFFFFF'; ctx.fillRect(0, 0, W, H);
    c.panels.forEach(function (p) {
      if (!ART[p.id] && !hasLayers(p.id)) return;
      var pg = pageOf(p), m = matOf(p);
      ctx.save();
      clipPanel(ctx, p);
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
      paintFace(ctx, pg.W, pg.H, p.id);
      ctx.restore();
    });
    ctx.restore();
    if (!opt.guides) return;
    var u = opt.u || Math.max(W, H) / 600;
    drawTplGuides(ctx, c.cv, u);
    ctx.save();
    c.panels.forEach(function (p) {
      var pg = pageOf(p), m = matOf(p);
      ctx.beginPath(); panelPath(ctx, p);
      ctx.setLineDash([u * 2, u * 3]); ctx.lineWidth = u; ctx.strokeStyle = 'rgba(12,13,13,0.45)'; ctx.stroke();
      ctx.setLineDash([]);
      if (opt.labels === false) return;
      // the panel's name, upright like its art, just under the table edge
      ctx.save();
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      var fs = Math.max(u * 10, Math.min(pg.H * 0.11, pg.W * 0.07, u * 15)), t = panelName(p).toUpperCase();
      ctx.font = '700 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var tw = ctx.measureText(t).width + fs, ty = Math.min(pg.H / 2, fs * 1.4);
      ctx.fillStyle = 'rgba(12,13,13,0.62)'; ctx.fillRect(pg.W / 2 - tw / 2, ty - fs * 0.75, tw, fs * 1.5);
      ctx.fillStyle = '#FFFFFF'; ctx.fillText(t, pg.W / 2, ty);
      ctx.restore();
    });
    ctx.restore();
  }

  // ---------- flat layout editor: the panel (or the whole cover) fits the stage; zoom in and pan to work on part of it ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the page's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole page, lay.cx / lay.cy = the view's center in page fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 1, cx: 0.5, cy: 0.5, ox: 0, oy: 0 };
  var ZMAX = 8;
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 520;
    var fit = Math.min(maxW / Wi, maxH / Hi), z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    if (c.whole) paintCover(ctx, c, { guides: true, u: 1 / z });
    else drawFlat(ctx, c, Wi, Hi, c.pid, true, 1 / z);
    syncZoomUi();
    drawWhere(c);
    try { root.dispatchEvent(new CustomEvent('ardor:table-view')); } catch (e) {}
  }
  function syncZoomUi() {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= ZMAX - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole page); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, ZMAX);
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  // turn the art on the panel being edited 90 degrees (d = 90 right, -90 left) around its center, keeping its size
  function rotateArt(d) {
    var a = editingArt(); if (!a || !a.img) return;
    var c = cfg(), g = geom(a, c.Wi, c.Hi);
    a.rot = (((a.rot || 0) + d) % 360 + 360) % 360;
    if (a.mode === 'custom') a.rw = g.h / c.Wi;
    S.artVer++; render();
  }
  function editingArt() { var c = cfg(); return c.whole ? null : (ART[c.pid] || null); }
  // "where this is on the table": a small map of the whole cover with the panel being edited filled in
  var WHERE = { front: 'Hangs down the front, facing your visitors.', top: 'Lies on the table top. It reads from the front.', left: 'Hangs down the left end, as you face the table.', right: 'Hangs down the right end, as you face the table.', back: 'Hangs down the back, behind the table.' };
  function whereText(c) {
    if (c.whole) return 'The whole cover, laid flat as printed. Pick a panel to edit it.';
    if (c.fam.id === 'runner') return c.pid === 'top' ? 'Runs across the table top. It reads from the front.' : (c.pid === 'back' ? 'Hangs down the back of the table.' : 'Hangs down the front, facing your visitors.');
    return WHERE[c.pid] || '';
  }
  function drawWhere(c) {
    var cv = $('[data-abb-where-map]'); if (!cv) return;
    var W = c.tplW, H = c.tplH, mw = 104, mh = 64, k = Math.min(mw / W, mh / H);
    var cw = Math.max(8, Math.round(W * k)), ch = Math.max(8, Math.round(H * k)), dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.style.width = cw + 'px'; cv.style.height = ch + 'px';
    if (cv.width !== Math.round(cw * dpr) || cv.height !== Math.round(ch * dpr)) { cv.width = Math.round(cw * dpr); cv.height = Math.round(ch * dpr); }
    var ctx = cv.getContext('2d'), z = k * dpr, u = 1 / z;
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z, 0, 0, z, 0, 0);
    ctx.beginPath(); cutPath(ctx, c.cv); ctx.fillStyle = '#ECEAE6'; ctx.fill();
    c.panels.forEach(function (p) {
      var on = !c.whole && p.id === c.pid;
      ctx.save(); ctx.beginPath(); cutPath(ctx, c.cv); ctx.clip();
      ctx.beginPath(); panelPath(ctx, p);
      if (on) { ctx.fillStyle = 'rgba(189,37,44,0.88)'; ctx.fill(); }
      else if (ART[p.id] || hasLayers(p.id)) { ctx.fillStyle = 'rgba(12,13,13,0.22)'; ctx.fill(); }
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(12,13,13,0.35)'; ctx.stroke();
      ctx.restore();
    });
    if (c.cv.folds && c.cv.folds.length) { ctx.beginPath(); c.cv.folds.forEach(function (f) { ctx.moveTo(f[0], f[1]); ctx.lineTo(f[2], f[3]); }); ctx.setLineDash([u * 3, u * 2]); ctx.lineWidth = u; ctx.strokeStyle = 'rgba(12,13,13,0.6)'; ctx.stroke(); ctx.setLineDash([]); }
    ctx.beginPath(); cutPath(ctx, c.cv); ctx.lineWidth = u * 1.2; ctx.strokeStyle = 'rgba(12,13,13,0.8)'; ctx.stroke();
    var lb = $('[data-abb-where-name]'); if (lb) lb.textContent = c.whole ? 'Whole cover' : panelName(c.panel);
    setText('[data-abb-where-txt]', whereText(c));
  }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    // drag the art to move it. Zoomed in: drag outside the art (or with the hand tool on) to move the view.
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(), c = cfg(), zoomed = lay.zoom > 1.001, onArt = false;
      if (a && a.img && !lay.hand) {
        if (!zoomed) onArt = true;
        else {
          var g = geom(a, c.Wi, c.Hi), r = cv.getBoundingClientRect();
          var ux = (e.clientX - r.left - lay.ox) / lay.scale, uy = (e.clientY - r.top - lay.oy) / lay.scale;
          onArt = ux >= g.x && ux <= g.x + g.w && uy >= g.y && uy <= g.y + g.h;
        }
      }
      if (!onArt && !zoomed) return;
      lay.drag = onArt; lay.pan = !onArt; lay.lx = e.clientX; lay.ly = e.clientY;
      if (lay.pan) cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (lay.pan) { var px = e.clientX - lay.lx, py = e.clientY - lay.ly; lay.lx = e.clientX; lay.ly = e.clientY; panBy(px, py); return; }
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { var was = lay.pan; lay.drag = false; lay.pan = false; if (was) syncZoomUi(); };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    // mouse wheel / trackpad over the stage: pinch or Ctrl + wheel zooms, the wheel moves the view when zoomed in
    cv.parentNode.addEventListener('wheel', function (e) {
      var r = cv.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.pow(0.996, e.deltaY), px, py); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault();
      panBy(-(e.shiftKey ? e.deltaY : e.deltaX), -(e.shiftKey ? 0 : e.deltaY));
    }, { passive: false });
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    on('[data-abb-bg]', 'input', function (e) { setBg(e.target.value); });
    on('[data-abb-rot-l]', 'click', function () { rotateArt(-90); });
    on('[data-abb-rot-r]', 'click', function () { rotateArt(90); });
    on('[data-abb-zoom2d-in]', 'click', function () { setZoom(lay.zoom * 1.5); });
    on('[data-abb-zoom2d-out]', 'click', function () { setZoom(lay.zoom / 1.5); });
    on('[data-abb-zoom2d-fit]', 'click', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on('[data-abb-hand]', 'click', function () { lay.hand = !lay.hand; syncZoomUi(); });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber). W x H = its panel.
  function resIssue(a, W, H) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, W, H), ppi = Math.round(a.natW / (rot90(a) ? g.h : g.w));
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    var c = cfg(), a = editingArt(), whole = c.whole;
    root.setAttribute('data-abb-view', whole ? 'whole' : 'panel');
    root.setAttribute('data-abb-panel-name', whole ? '' : panelName(c.panel));
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = whole ? 'Upload artwork' : 'Upload art for the ' + panelName(c.panel).toLowerCase();
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = whole || !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (whole) { empty.hidden = false; empty.textContent = 'This is the whole cover, laid flat as printed. Pick a panel above to edit it.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the cover will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = 'No artwork on the ' + panelName(c.panel).toLowerCase() + ' yet. Upload it above, add text, or leave it plain in the cover color.'; }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
    }
    // image resolution on every panel; the worst one is shown, in the footer, where it is always in view
    var worst = null, wp = null;
    c.panels.forEach(function (p) { var pg = pageOf(p), r = resIssue(ART[p.id], pg.W, pg.H); if (r && (!worst || (r.level === 'bad' && worst.level !== 'bad'))) { worst = r; wp = p; } });
    if (worst) { msg = 'The image on the ' + panelName(wp).toLowerCase() + worst.text; level = worst.level; }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
    syncBgUi();
  }

  // ---------- render ----------
  function specLines(c) {
    var out = [['Cover', famLabel(c)], ['Size', sizeLabel(c)]];
    if (c.sides) out.push(['Sides', sidesLabel(c)]);
    if (c.combo && c.color) out.push(['Throw color', colorLabel(c)]);
    out.push(['Cover color', bgLabel(c)], ['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    return out;
  }
  // small icons for the cover type cards (24 x 24, seen from the front)
  var SIL = {
    throw: 'M3 6.5h18l1.2 13.5H1.8Z',
    fitted: 'M3 6.5h18V20H3Z',
    stretch: 'M3 6h18v3.2l-2.2 1.3V20h-2.2v-9.3H7.4V20H5.2v-9.5L3 9.2Z',
    round: 'M2.5 8.5c0-1.9 4.3-3.4 9.5-3.4s9.5 1.5 9.5 3.4L22.8 20H1.2Z',
    runner: 'M3 8h18v1.6H3ZM9 6.4h6V20H9ZM4.2 9.6h1.4V20H4.2Zm14.2 0h1.4V20h-1.4Z'
  };
  function famIcon(id) {
    return '<svg class="abb-opt__sil" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="' + (SIL[id] || SIL.throw) + '" fill="currentColor" opacity=".85"/></svg>';
  }
  // the panel tabs, "Whole cover" and "Copy this panel to..." on the stage toolbar
  function renderTabs(c) {
    var box = $('[data-abb-art-tabs]'); if (!box) return;
    box.hidden = false;
    var nodes = c.panels.map(function (p) {
      var b = document.createElement('button'), has = !!ART[p.id] || hasLayers(p.id);
      b.type = 'button'; b.className = 'abb-art-tab'; b.setAttribute('data-abb-panel', p.id);
      b.setAttribute('aria-pressed', !c.whole && p.id === c.pid ? 'true' : 'false');
      b.innerHTML = esc(panelName(p).replace(/ (side|drop)$/i, '')) + (has ? '<i class="abb-art-tab__dot" aria-hidden="true"></i>' : '');
      b.title = has ? panelName(p) + ': has art' : panelName(p) + ': no art yet';
      b.addEventListener('click', function () { pickPanel(p.id); });
      return b;
    });
    var w = document.createElement('button');
    w.type = 'button'; w.className = 'abb-art-tab abb-art-tab--whole'; w.setAttribute('data-abb-panel', 'whole');
    w.setAttribute('aria-pressed', c.whole ? 'true' : 'false'); w.textContent = 'Whole cover'; w.title = 'See the whole cover as printed (view only)';
    w.addEventListener('click', function () { pickPanel('whole'); });
    nodes.push(w);
    var targets = c.panels.filter(function (p) { return p.id !== c.pid; });
    if (!c.whole && targets.length) {
      var sel = document.createElement('select'), drops = targets.filter(function (p) { return p.id !== 'top'; });
      sel.className = 'abb-copy'; sel.setAttribute('data-abb-copy', ''); sel.setAttribute('aria-label', 'Copy this panel to another panel');
      var opts = '<option value="">Copy this panel to…</option>';
      targets.forEach(function (p) { opts += '<option value="' + esc(p.id) + '">' + esc(panelName(p)) + '</option>'; });
      if (drops.length > 1) opts += '<option value="drops">' + (c.pid === 'top' ? 'All the drops' : 'All the other drops') + ' (' + esc(drops.map(function (p) { return panelName(p).toLowerCase(); }).join(', ')) + ')</option>';
      sel.innerHTML = opts;
      sel.disabled = !(ART[c.pid] || hasLayers(c.pid));
      sel.title = sel.disabled ? 'Add art to this panel first' : 'Copy this panel to another panel (scaled to fit)';
      sel.addEventListener('change', function () { var v = sel.value; sel.value = ''; if (v) copyPanel(v); });
      nodes.push(sel);
    }
    fill(box, nodes);
  }

  function render() {
    var c = cfg();
    var p = price(c);
    var ks = coversShown();

    // 1. cover type: one card per type with its icon and its lowest price
    fill($('[data-abb-shapes]'), famsShown().map(function (f) {
      var lo = famFrom(f.id);
      var html = famIcon(f.id) + '<span class="abb-opt__name">' + esc(f.plural) + '</span><span class="abb-opt__price">' + (lo > 0 ? 'from ' + money(lo / 100) : 'Call us') + '</span>';
      return optBtn({ on: f.id === c.cv.fam, html: html, data: ['fam', f.id], pick: function () { pickFamily(f.id); } });
    }));

    // 2. size: the sizes of that type, priced with the chosen version. Runners: a width and a length.
    var seen = {}, sizes = [];
    ks.forEach(function (k) { if (CV[k].fam === c.cv.fam && !seen[CV[k].sz]) { seen[CV[k].sz] = 1; sizes.push(CV[k].sz); } });
    var szBox = $('[data-abb-sizes]'); if (szBox) szBox.classList.toggle('abb-sizes--runner', c.fam.id === 'runner');
    var keyFor = function (sz) { var same = ks.filter(function (k) { return CV[k].fam === c.cv.fam && CV[k].sz === sz; }); return same.filter(function (k) { return String(CV[k].opt || '') === c.opt; })[0] || same[0]; };
    if (c.fam.id === 'runner') {
      var runs = ks.filter(function (k) { return CV[k].fam === 'runner'; }), ws = [], ls = [];
      runs.forEach(function (k) { if (ws.indexOf(+CV[k].rw) < 0) ws.push(+CV[k].rw); if (ls.indexOf(+CV[k].rl) < 0) ls.push(+CV[k].rl); });
      ws.sort(function (a, b) { return a - b; }); ls.sort(function (a, b) { return a - b; });
      var cur = variantFor(c.key).cents, sum = document.createElement('div');
      sum.className = 'abb-opt abb-opt--sum'; sum.setAttribute('aria-pressed', 'true');
      sum.innerHTML = '<span class="abb-opt__name">' + esc(sizeName(c.key)) + ' runner</span><span class="abb-opt__sub">' + esc(sizeSub(c.key)) + '</span><span class="abb-opt__price">' + (cur > 0 ? money(cur / 100) : 'Call us') + '</span>';
      var lab = function (t) { var x = document.createElement('p'); x.className = 'abb-sub abb-sizes__label'; x.textContent = t; return x; };
      var chip = function (n, on, pick, kind) { return optBtn({ chip: true, on: on, data: [kind, n], label: fmt(n) + ' in', pick: pick }); };
      fill($('[data-abb-sizes]'), [sum, lab('Length (front to back)')].concat(ls.map(function (l) { return chip(l, l === +c.cv.rl, function () { pickRunner(0, l); }, 'rl'); }))
        .concat([lab('Width')]).concat(ws.map(function (w) { return chip(w, w === +c.cv.rw, function () { pickRunner(w, 0); }, 'rw'); })));
    } else {
      fill($('[data-abb-sizes]'), sizes.map(function (sz) {
        var k0 = keyFor(sz), cents = variantFor(k0).cents;
        var html = '<span class="abb-opt__name">' + esc(sizeName(k0)) + '</span><span class="abb-opt__sub">' + esc(sizeSub(k0)) + '</span><span class="abb-opt__price">' + (cents > 0 ? money(cents / 100) : 'Call us') + '</span>';
        return optBtn({ on: sz === c.cv.sz, html: html, data: ['size', sz], disabled: !(cents > 0), pick: function () { pickSize(sz); } });
      }));
    }

    // 3. the version of this size: 3 or 4 sided (throws, fitted covers), runner only or with a solid throw (runners)
    var optKs = ks.filter(function (k) { return CV[k].fam === c.cv.fam && CV[k].sz === c.cv.sz && CV[k].opt; });
    var sWrap = $('[data-abb-sides-wrap]'); if (sWrap) sWrap.hidden = optKs.length < 2;
    var oLabel = c.fam.id === 'runner' ? 'Solid throw' : 'Sides';
    $$('[data-abx-row="sides"] .abx-row__label, [data-abb-sides-title]').forEach(function (el) { el.textContent = oLabel; });
    fill($('[data-abb-sides]'), optKs.length > 1 ? optKs.map(function (k) {
      var cents = variantFor(k).cents;
      var html = '<span class="abb-opt__name">' + esc(CV[k].optName || k) + '</span><span class="abb-opt__sub">' + esc(CV[k].optSub || '') + '</span>' + (cents > 0 ? '<span class="abb-opt__price">' + money(cents / 100) + '</span>' : '');
      return optBtn({ on: k === c.key, data: ['opt', CV[k].opt], disabled: !(cents > 0), html: html, pick: function () { pickOpt(String(CV[k].opt)); } });
    }) : []);
    setText('[data-abb-sides-note]', c.sides === 3 ? 'The back of the table stays open.' : (c.sides === 4 ? 'The cover hangs on all four sides, the back too.' : (c.combo ? 'The solid throw is not printed. Pick its color below.' : '')));

    // 4. throw color: only for the runner + solid color throw
    var cWrap = $('[data-abb-color-wrap]'); if (cWrap) cWrap.hidden = !c.combo;
    fill($('[data-abb-colors]'), c.combo ? colorsFor(c.cv).map(function (x) {
      var b = optBtn({ chip: true, on: !!c.color && c.color.name === x.name, data: ['color', x.name], html: '<span class="abb-swatch" style="background:' + esc(x.hex) + '"></span><span>' + esc(x.name) + '</span>', pick: function () { pickColor(x.name); } });
      b.title = x.name; return b;
    }) : []);
    setText('[data-abb-color-note]', c.combo ? 'The solid color throw goes on the table under your printed runner. The throw is not printed.' : '');

    // 5. cover color: white, black or any color
    fill($('[data-abb-bgs]'), BG_SWATCHES.map(function (x) {
      return optBtn({ chip: true, on: c.bg === x[1], data: ['bg', x[1]], html: '<span class="abb-swatch" style="background:' + x[1] + '"></span><span>' + x[0] + '</span>', pick: function () { setBg(x[1]); } });
    }));
    setText('[data-abb-bg-note]', 'Shows everywhere your art does not cover' + (c.fam.id === 'throw' ? ', the corners too' : '') + '. Now: ' + bgLabel(c) + '.');

    // 6. quantity: 1 to 100 covers
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1; if (qp) qp.disabled = c.qty >= MAX_QTY;
    setText('[data-abb-qty-note]', c.qty > 1 ? qtyLabel(c.qty, c) + ' at ' + money(p.each) + ' each: ' + money(p.charged) + '. All of them have the same art.' : money(p.each) + ' each. All ' + nounOf(c, 2) + ' in an order have the same art.');

    // 7. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping to your address</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    renderTabs(c);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then covers x price
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2;
    eachEl.textContent = qtyLabel(c.qty, c) + ' x ' + money(p.each);
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.');
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = dl; });

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', sizeChip(c));
    setText('[data-abb-chip-mat]', c.whole ? 'Whole cover' : panelName(c.panel));
    setText('[data-abb-chip-sides]', qtyLabel(c.qty, c) + (c.sides ? ', ' + c.sides + ' sided' : ''));
    setText('[data-abb-tip]', c.whole ? 'Pick a panel to edit it' : 'Keep text and logos inside the red line. Dashed line: table edge.');
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorTable3D, three.js). Everything else works without it. ----------
  var texCv = null, engSent = '', texSent = '', syncQueued = false;
  // the whole cover as printed, at the template's proportions (up to 2048 px), for the 3D cloth
  function paintTexture(c) {
    var k = Math.min(24, 2048 / Math.max(c.tplW, c.tplH));
    var w = Math.max(2, Math.round(c.tplW * k)), h = Math.max(2, Math.round(c.tplH * k));
    var cv = texCv || (texCv = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    ctx.setTransform(w / c.tplW, 0, 0, h / c.tplH, 0, 0);
    paintCover(ctx, c, { guides: false });
    return cv;
  }
  // the 3D table gets the cover's template geometry (table-specs) once per cover, then the whole cover as its texture
  function sync3d() {
    if (!eng) return;
    var c = cfg();
    try {
      var under = c.combo && c.color ? c.color.hex : null, key = [c.key, under || ''].join('|');
      if (key !== engSent) {
        engSent = key; texSent = '';
        eng.set({ key: c.key, family: c.cv.fam, table: c.cv.table, tpl: { w: c.tplW, h: c.tplH }, cut: c.cv.cut, top: c.cv.top, folds: c.cv.folds || [], panels: c.panels, sides: +c.cv.sides || 4, under: under });
      }
      var tx = paintTexture(c), tk = tx.width + 'x' + tx.height + '|' + engSent;
      if (texSent !== tk) { texSent = tk; eng.setTexture(tx); }
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (!eng || syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorTable3D && host) ? window.ArdorTable3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
  // the whole cover as printed, with its guides and panel names (the approval box and the proof's print file page)
  function proofCanvas() {
    var c = cfg(), W = c.tplW, H = c.tplH, long = 2000, cw, ch;
    if (W >= H) { cw = long; ch = Math.max(60, Math.round(long * H / W)); } else { ch = long; cw = Math.max(60, Math.round(long * W / H)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / W, 0, 0, ch / H, 0, 0);
    paintCover(ctx, c, { guides: true, u: (Math.max(W, H) / long) * 2.2 });
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var r = a.rot || 0, ia = rot90(a) ? nh / nw : nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi, rot: r };
      var fw0 = Math.min(Wi, Hi * ia), fh0 = fw0 / ia;
      return { x: (Wi - fw0) / 2, y: (Hi - fh0) / 2, w: fw0, h: fh0, rot: r, note: 'An uploaded PDF is a different shape than its panel, so it was placed to fit, centered, with the cover color around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, rot: r };
  }

  function loadPdfTool() {
    if (window.ArdorTablePDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorTablePDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, W, H) {
    if (!a) return '';
    if (!a.img) return 'Fit whole file';
    var turn = a.rot === 90 ? ', turned 90 degrees right' : (a.rot === 270 ? ', turned 90 degrees left' : (a.rot === 180 ? ', turned upside down' : ''));
    if (a.mode === 'fill') return 'Fill panel (edges may crop)' + turn;
    if (a.mode === 'fit') return 'Fit whole image' + turn;
    var g = geom(a, W, H);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the panel\'s top-left (upright)' + turn;
  }
  // the panels that carry a design (art, text or clipart); the rest show the cover color only
  function designed(c) { return c.panels.filter(function (p) { return !!ART[p.id] || hasLayers(p.id); }); }
  function panelsLabel(c) { var d = designed(c); return d.length ? d.map(panelName).join(', ') : 'None (cover color only)'; }
  function artworkLabel(c) {
    c = c || cfg();
    var out = designed(c).map(function (p) { var a = ART[p.id]; return panelName(p) + ': ' + (a ? a.name : 'text and clipart added in the builder'); });
    return out.length ? out.join('; ') : 'None (cover color only)';
  }
  function placementLines(c) { return designed(c).map(function (p) { var pg = pageOf(p), t = placementText(ART[p.id], pg.W, pg.H); return t ? panelName(p) + ': ' + t : ''; }).filter(Boolean).join('; '); }
  function printFileLabel(c) { return 'One page, ' + tplTxt(c) + ': the whole cover template, bleed included'; }

  function proofSpecs(c) {
    var out = [['Cover', famLabel(c)], ['Size', sizeLabel(c)]];
    if (c.sides) out.push(['Sides', sidesLabel(c)]);
    out.push(['Background', bgLabel(c)], ['Panels designed', panelsLabel(c)]);
    if (c.combo && c.color) out.push(['Throw color', colorLabel(c)]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)], ['Artwork', artworkLabel(c)], ['Print size', printFileLabel(c)]); // the shared proof sheet adds its own "Print file" row
    var pl = placementLines(c); if (pl) out.push(['Placement', pl]);
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
  // the 3D views on the proof: from the front and from the back, in ONE picture (front on top, back below), because the
  // shared proof sheet shows a single 3D picture when the print file fits next to it (wide covers)
  function proofViews(c) {
    try { sync3d(); } catch (e) {}
    if (!eng || typeof eng.snapshot !== 'function') return [];
    try {
      var a = eng.snapshot(1000, 515, 'home'), b = eng.snapshot(1000, 515, 'back');
      if (!a || !b) { var one = a || b; return one ? [{ canvas: one, caption: a ? 'From the front' : 'From the back' }] : []; }
      var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 1030;
      var x = cv.getContext('2d');
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, 1000, 1030);
      x.drawImage(a, 0, 0); x.drawImage(b, 0, 515);
      x.fillStyle = '#DCDDE0'; x.fillRect(24, 514, 952, 2);
      x.fillStyle = '#6B6F76'; x.font = '600 26px Arial, sans-serif'; x.textBaseline = 'top';
      x.fillText('From the front', 24, 22); x.fillText('From the back', 24, 537);
      return [{ canvas: cv, caption: 'From the front (top) and from the back (bottom)' }];
    } catch (e) { return []; }
  }
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = nounOf(c, c.qty); o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
  // The proof, and ONE print file: the whole cover template page (template x 72 pt), the cover color everywhere, every
  // designed panel placed and turned as printed (ArdorTablePDF.buildSheet). A panel with text or clipart is flattened to one
  // image of that panel (artwork + layers); the others use the customer's own file (pictures, PDF / AI vector art).
  function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorTablePDF, W = c.tplW, H = c.tplH;
      var out = { notes: [], proof: null, print: null };
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      var used = designed(c);
      var faces = [{ label: 'Whole cover, laid flat as printed', canvas: proofCanvas(), fallback: null, wIn: W, hIn: H, wLabel: fmt(W) + ' in', hLabel: fmt(H) + ' in', underlay: null }];
      var date = (approval && approval.when) || stampLabel(new Date());
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor Table Cover Proof', panelTitle: 'Your ' + nounOf(c, c.qty), sideBySide: false,
          legend: 'Solid black line: cut line (hemmed edge). Dashed black lines: table edges. Dotted lines: panel edges. Print page ' + fmt(W) + ' x ' + fmt(H) + ' in (width x height), bleed included.',
          approval: approval || null, date: date, faces: faces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var printable = function (p) { var a = ART[p.id]; return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(p.id); };
      var printP = Promise.resolve();
      if (proofMode === 'preview') { /* PDF button: the proof only, no print file */ }
      else if (!used.every(printable)) out.notes.push('The print file was not made automatically for this file type. Use the original artwork files.');
      else {
        if (used.some(function (p) { return ART[p.id] && ART[p.id].src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        var items = [], chain = Promise.resolve();
        used.forEach(function (p) {
          chain = chain.then(function () {
            var a = ART[p.id], pg = pageOf(p), m = matOf(p), r0 = rotOf(p);
            // a box on the upright panel -> the box on the template, turned with the panel
            var toTpl = function (g) { var b = boxTo(m, g); b.rot = (((g.rot || 0) + r0) % 360 + 360) % 360; if (g.note) b.note = g.note; return b; };
            if (a && a.rotated && out.notes.indexOf(ROT_NOTE) < 0) out.notes.push(ROT_NOTE);
            if (hasLayers(p.id)) {
              return window.ArdorTableLayers.composite(p.id, pg.W, pg.H, a).then(function (r) {
                if (out.notes.indexOf(LAYER_NOTE) < 0) out.notes.push(LAYER_NOTE);
                items.push({ panel: p.id, art: { file: r.file, name: r.file.name, kind: 'image' }, clip: clipOf(p), sizeIn: { w: pg.W, h: pg.H }, geomFor: function () { return toTpl({ x: 0, y: 0, w: pg.W, h: pg.H, rot: 0 }); } });
              });
            }
            items.push({ panel: p.id, art: a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a), clip: clipOf(p), sizeIn: { w: pg.W, h: pg.H }, geomFor: function (nw, nh) { return toTpl(geomForArt(a, nw, nh, pg.W, pg.H)); } });
            return null;
          });
        });
        printP = chain.then(function () {
          return P.buildSheet({ title: 'Ardor Table Cover Print File', stamp: date, Wi: W, Hi: H, bg: S.bg || '#FFFFFF', items: items });
        }).then(function (r) {
          r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); });
          out.print = r.blob;
        }).catch(function (e) { out.print = null; out.notes.push('The print file could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork files.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name === 'ardor_table_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    try { if (window.fbq) window.fbq('track', name === 'ardor_table_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var cv = proofCanvas();
      var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
      var im = new Image(); im.alt = 'Your table cover proof, laid flat as printed'; im.src = cv.toDataURL('image/jpeg', 0.86);
      var cap = document.createElement('figcaption');
      var orig = designed(c).filter(function (q) { var a = ART[q.id]; return a && a.kind !== 'image'; }).map(function (q) { return ART[q.id].name; });
      cap.textContent = 'Whole cover, laid flat as printed: ' + coverLabel(c) + ', ' + fitsTxt(c) + '. Panels designed: ' + panelsLabel(c) + '.' + (orig.length ? ' We print from your original file' + (orig.length > 1 ? 's' : '') + ' (' + orig.join(', ') + ').' : '');
      fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // One line: the cover variant, quantity = the number of covers, everything else as line item properties (visible ones
  // for the customer, hidden "_" ones for our team): the signed proof, the print file (the whole template) and each
  // panel's own artwork file.
  function setupMsg() { return 'Online ordering for this cover is being set up. Call ' + PHONE + ' or request a quote.'; }

  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    if (!p.vid || !c.v.available) { showErr(setupMsg()); return; }
    var used = designed(c);
    if (!used.length) {
      if (c.whole) { S.view = 'panel'; render(); }
      showErr('Upload your artwork first, or add text in the designer.');
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false;
    var waits = used.map(function (q) { return ART[q.id]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof();
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval);
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      fd.append('properties[Cover]', famLabel(c));
      fd.append('properties[Size]', sizeLabel(c));
      if (c.sides) fd.append('properties[Sides]', sidesLabel(c));
      if (c.combo && c.color) fd.append('properties[Throw color]', colorLabel(c));
      fd.append('properties[Background]', bgLabel(c));
      fd.append('properties[Panels designed]', panelsLabel(c));
      fd.append('properties[Quantity]', qtyLabel(c.qty, c));
      fd.append('properties[Delivery]', deliveryLabel(c));
      fd.append('properties[Artwork]', artworkLabel(c));
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor Table Cover Designer');
      var pl = placementLines(c); if (pl) fd.append('properties[_Art placement]', pl);
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the builder]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor Table Cover Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Table Cover Proof'));
      else if (files.proof) fd.append('properties[_Ardor Table Cover Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Table Cover Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', 'We\'ll email you a proof to approve before printing');
      if (approval) {
        fd.append('properties[Approved by]', approval.name);
        fd.append('properties[Approved on]', approval.when);
        fd.append('properties[_Approver email]', approval.email);
        fd.append('properties[_Approver phone]', approval.phone);
      }
      if (files.print) {
        if (files.print.size <= MAXPDF) fd.append('properties[_Ardor Table Cover Print File - ' + labelStamp + ']', pdfFile(files.print, 'Ardor Table Cover Print File'));
        else files.notes.push('The print file was over 25 MB, so it was not attached. Use the original artwork files.');
      }
      var pnote = ['Cover ' + c.key + ' (' + (c.v.sku || ('TC-' + c.key)) + '): ' + coverLabel(c) + ', ' + fitsTxt(c) + '. Template page ' + tplTxt(c) + (c.cv.tplName ? ' (' + c.cv.tplName + ')' : '') + '. Background ' + c.bg + (c.combo && c.color ? '. Solid throw under the runner: ' + c.color.name : '') + '. Quantity: ' + qtyLabel(c.qty, c) + '. Delivery: ' + (c.delivery === 'pickup' ? 'pickup in Snohomish' : 'ship to the customer (blind ship)') + '.'];
      pnote.push('Panels designed: ' + used.map(function (q) { return panelName(q) + ' (turned ' + rotOf(q) + ' degrees onto the template)'; }).join(', ') + '. Other areas: background color only.');
      if (files.print) pnote.push('The print file is the whole template page, ' + tplTxt(c) + ', art to the page edge (bleed included), no guides, 100% scale.');
      if (c.cv.placeholder) pnote.push('Check the template: this cover used placeholder geometry.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      // each panel's own artwork file (a file copied to other panels is attached once)
      var sent = [];
      used.forEach(function (q) {
        var a = ART[q.id]; if (!a || !a.file || sent.indexOf(a.file) >= 0) return;
        sent.push(a.file);
        fd.append('properties[Ardor Table Cover Artwork ' + panelName(q) + ' - ' + labelStamp + ']', a.file, 'Ardor Table Cover Artwork ' + panelName(q) + ' ' + fileStamp + ext(a.name));
      });
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, cover: c.key, sku: c.v.sku || '', sides: c.sides || 0, n: c.qty, each: p.each, total: p.charged, del: c.delivery, bg: c.bg, color: c.combo && c.color ? c.color.name : '', panels: used.map(function (q) { return q.id; }), page: [c.tplW, c.tplH] }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      track('ardor_table_added_to_cart', { value: p.charged, cover: c.key, quantity: c.qty, panels: used.length });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Panels designed: ' + panelsLabel(c));
    designed(c).forEach(function (q) { var a = ART[q.id]; if (a) lines.push(panelName(q) + ' artwork: ' + a.name + ' (I will send the file)'); });
    var pl = placementLines(c); if (pl) lines.push('Placement: ' + pl);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + qtyLabel(c.qty, c) + ' x ' + money(p.each) + ')');
    return lines.join('\n');
  }

  function openQuote(want) {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText() + (typeof want === 'number' && want > MAX_QTY ? '\nQuantity wanted: ' + want : '');
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Table covers from the Ardor Table Cover Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f)); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f)); });
    // the panel tabs and "Copy this panel to..." are made (and wired) by renderTabs() on every render
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d(cfg().whole ? 'home' : view3dFor(cfg().pid)); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_table_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindOptions();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // quantity box and the cover color; the PDF proof button on the tool rail
  function bindOptions() {
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v >= 1) setQty(Math.min(MAX_QTY, v)); if (v > MAX_QTY) { q.value = String(MAX_QTY); openQuote(v); } });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
    on('[data-abb-bg]', 'change', function (e) { setBg(e.target.value); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // the table cover designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorTableBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); PS.preview(B.proof); });
    B.proof._btn = btn;
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    window.ArdorTableBuilder = {
      state: S, specs: SPECS, covers: coversShown, live: function () { return LIVE; }, cfg: cfg, price: price, render: render, variantFor: variantFor, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); },
      pickCover: pickCover, pickFamily: pickFamily, pickSize: pickSize, pickOpt: pickOpt, pickRunner: pickRunner, pickColor: pickColor, pickPanel: pickPanel, copyPanel: copyPanel, setBg: setBg, setZoom: setZoom,
      paintCover: function (ctx, opt) { paintCover(ctx, cfg(), opt || {}); }, texture: function () { return paintTexture(cfg()); },
      panel: function (id) { var p = panelOf(cfg().key, id); return p ? { id: p.id, name: panelName(p), rect: R(p.rect), rot: rotOf(p), page: pageOf(p), mat: matOf(p), safe: safeBoxOf(cfg(), p) } : null; },
      art: function (id) { return ART[id] || null; },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-table-layers.js (text and clipart layers). Sizes are in inches (c.Wi x c.Hi).
    window.ArdorTableAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[face] || null; },
      setArt: function (face, a) { ART[face] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      // the panel being edited (null in the Whole cover view: nothing is edited there)
      editFace: function () { var c = cfg(); return c.whole ? null : c.pid; },
      // a panel's upright page in inches (null when the cover has no such panel), and the panels of the cover
      pageSize: function (face) { var p = panelOf(cfg().key, face), g = p ? pageOf(p) : null; return g ? { Wi: g.W, Hi: g.H } : null; },
      faces: function () { return cfg().panels.map(function (p) { return p.id; }); },
      artGeom: function (f, Wi, Hi) {
        var c = cfg(), a = typeof f === 'string' ? artFor(f) : f, p = typeof f === 'string' ? panelOf(c.key, f) : null, g = p ? pageOf(p) : { W: c.Wi, H: c.Hi };
        return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || g.W, Hi || g.H) : null;
      },
      // where the page sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = page corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      // a panel's whole upright page (AI designs are placed to fill it), and the panel being edited inside its safe line
      // (new text and logos go there)
      faceBox: function (face) { var c = cfg(), p = panelOf(c.key, face) || c.panel, g = pageOf(p); return { x: 0, y: 0, w: g.W, h: g.H }; },
      safeBox: function () { var c = cfg(); return c.whole ? null : safeBoxOf(c, c.panel); },
      pickCover: pickCover, coverKey: function () { return cfg().key; },
      coverInfo: function (key) { var k = normKey(key); return k ? { key: k, fam: CV[k].fam, name: CV[k].name || k } : null; },
      covers: coversShown, pickPanel: pickPanel,
      panelInfo: function (id) { var c = cfg(), p = panelOf(c.key, id || c.pid); if (!p) return null; var g = pageOf(p); return { id: p.id, name: panelName(p), W: g.W, H: g.H, round: !!(p.clip && p.clip.circle) }; },
      coverName: function () { var c = cfg(); return coverLabel(c); }
    };
    window.ArdorTableBuilder.proof = { noun: 'table covers', file: 'Ardor Table Cover Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = c.panels.map(function (q) { return ART[q.id]; }).filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:table-api')); } catch (e) {}
    mountPdf(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
